const files = import.meta.glob('./*.js', { eager: true });
const modules = {};

Object.keys(files).forEach((key) => {
	if (key === './index.js') return;
	const m = key.match(/^\.\/(.+)\.js$/);
	if (!m) return;
	const moduleName = m[1];
	modules[moduleName] = files[key].default;
});

export default modules;
